import { render } from "./Marvel.vue?vue&type=template&id=72d8a728"
import script from "./Marvel.vue?vue&type=script&lang=js"
export * from "./Marvel.vue?vue&type=script&lang=js"
script.render = render

export default script